import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import useLocalStorage from '@zenbusiness/application-commons-hooks/useLocalStorage';
import { useNavigate } from 'react-router-dom';

import { RELEASE_INVOICING_FEATURE_ANNOUNCEMENT_BANNER } from '#client/constants/experimentsFlags';
import { MFE_PATHS } from '#client/constants/paths';
import { INVOICING_FEATURE_BANNER } from '#client/constants/whatNewBanner';
import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import { useDashboardPath } from '#client/hooks/useDashboardPath';
import useFeatureFlag from '#client/hooks/useFeatureFlag';
import useWhatsNewBannerContext from '#client/hooks/useWhatNewBannerContext';

const useInvoicingBanner = () => {
  const [isInvoicingBannerEnabled, isLoadingInvoicingBannerFlag] = useFeatureFlag(
    RELEASE_INVOICING_FEATURE_ANNOUNCEMENT_BANNER
  );
  const { businessEntityUuid, entitlements } = useConstBusinessEntityUuid();
  const path = useDashboardPath(MFE_PATHS.INVOICING);
  const navigate = useNavigate();

  const { removeBanner } = useWhatsNewBannerContext();
  const buttonPressedTracker = useClickstreamCallback('buttonPressed');

  const hasBanking = entitlements.has('banking');
  const hasMoneyPro = entitlements.has('money_pro');

  /**
   * Store the whats_new_banner in the local storage to prevent show whats new banner
   */
  const [invoicingBannerCache, setInvoicingBannerCache] = useLocalStorage(
    `${INVOICING_FEATURE_BANNER.type}.${businessEntityUuid}`,
    false
  );

  /**
   * Show the banner if the user is approved, has banking, and doesn't have money pro
   */
  const isShowInvoicingBanner =
    !isLoadingInvoicingBannerFlag &&
    isInvoicingBannerEnabled &&
    !invoicingBannerCache &&
    hasBanking &&
    !hasMoneyPro;

  const handleClose = () => {
    buttonPressedTracker({
      elementName: 'close_invoicing_announcement',
      elementText: 'close',
      appPageName: 'active_banking_dashboard',
      appSection: 'banking'
    });
    removeBanner(INVOICING_FEATURE_BANNER.type);
    setInvoicingBannerCache(true);
  };

  const handleClickTryNow = () => {
    buttonPressedTracker({
      elementName: 'try_now_invoicing_banner_banking',
      elementText: 'Get started',
      appPageName: 'active_banking_dashboard',
      appSection: 'banking'
    });
    removeBanner(INVOICING_FEATURE_BANNER.type);
    setInvoicingBannerCache(true);
    navigate(path);
  };

  return {
    isShowInvoicingBanner,
    handleClose,
    handleClickTryNow
  };
};

export default useInvoicingBanner;
